import { connect } from 'react-redux';
import QueryHistory from './components/QueryHistory';
import {
  loadUser,
  loadMySubscriptionPlan,
  loadUsersInfo,
} from '../../redux/actions/user';

import {
  loadHistoryQueries,
  updateHistoryQuery,
  addNewHistoryQuery,
  copyHistoryQueryResult,
  clearCopyHistoryQueryResult,
  downloadHistoryQueryResult,
} from '../../redux/actions/ioc';

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    organisation_users_info: state.user.organisation_users_info,
    historyQueries: state.ioc.historyQueries,
    historyQueriesCount: state.ioc.historyQueriesCount,
    historyQueriesStatus: state.ioc.historyQueriesStatus,
    copyQueryHistoryResultStatus: state.ioc.copyQueryHistoryResultStatus,
    queryHistoryResults: state.ioc.queryHistoryResults,
    downloadQueryHistoryResultStatus:
      state.ioc.downloadQueryHistoryResultStatus,
    mySubscriptionPlan: state.user.mySubscriptionPlan,
    mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
    token: state.auth.token,
  };
};

const mapDispatchToProps = {
  loadUser,
  loadUsersInfo,
  loadHistoryQueries,
  loadMySubscriptionPlan,
  updateHistoryQuery,
  addNewHistoryQuery,
  copyHistoryQueryResult,
  clearCopyHistoryQueryResult,
  downloadHistoryQueryResult,
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryHistory);
